import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _Promise from '@babel/runtime-corejs3/core-js/promise';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import { useRef } from 'react';
import { script, api } from '@bilibili-maoer/web-utils';
import { constant } from 'lodash-es';
import useMount from 'react-use/lib/useMount';
import { fetchCaptchaChallenge } from '../account/api/captcha.js';
import '../utils/fetcher.js';
import 'qs';
import { ECaptchaType } from '../account/components/types.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function loadGeetest() {
  return script.loadScript('geetest-js', "".concat(api.MISSEVAN_CDN_PREFIX_URL, "/assets/third_party/gt.js"), true);
}

var useGeetest = function useGeetest(_ref) {
  var type = _ref.type;
  var captchaRef = useRef();
  var geetestInstanceRef = useRef();

  var updateCaptcha = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$fetchCaptchaCh, info;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchCaptchaChallenge(type);

            case 2:
              _yield$fetchCaptchaCh = _context.sent;
              info = _yield$fetchCaptchaCh.info;
              captchaRef.current = info === null || info === void 0 ? void 0 : info.params;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function updateCaptcha() {
      return _ref2.apply(this, arguments);
    };
  }();

  useMount(function () {
    if (!window.initGeetest) {
      loadGeetest();
    }

    updateCaptcha();
  });

  var verify = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _window$initGeetest;

      var initGeetest, gt;
      return _regeneratorRuntime.wrap(function _callee3$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (captchaRef.current) {
                _context5.next = 3;
                break;
              }

              _context5.next = 3;
              return updateCaptcha();

            case 3:
              if (!((_window$initGeetest = window.initGeetest) !== null && _window$initGeetest !== void 0)) {
                _context5.next = 7;
                break;
              }

              _context5.t0 = _window$initGeetest;
              _context5.next = 10;
              break;

            case 7:
              _context5.next = 9;
              return loadGeetest().then(function () {
                return window.initGeetest;
              }, constant(undefined));

            case 9:
              _context5.t0 = _context5.sent;

            case 10:
              initGeetest = _context5.t0;

              if (initGeetest) {
                _context5.next = 13;
                break;
              }

              return _context5.abrupt("return", {
                success: false,
                message: 'geetest-js 加载失败'
              });

            case 13:
              if (geetestInstanceRef.current) {
                _context5.next = 19;
                break;
              }

              _context5.next = 16;
              return new _Promise(function (resolve) {
                initGeetest(_objectSpread(_objectSpread({}, captchaRef.current), {}, {
                  offline: !captchaRef.current,
                  new_captcha: true,
                  product: 'bind'
                }), function (res) {
                  return resolve(res);
                });
              });

            case 16:
              geetestInstanceRef.current = _context5.sent;
              _context5.next = 20;
              break;

            case 19:
              geetestInstanceRef.current.verify();

            case 20:
              gt = geetestInstanceRef.current;

              if (gt) {
                _context5.next = 23;
                break;
              }

              return _context5.abrupt("return", {
                success: false,
                message: 'geetest 初始化失败'
              });

            case 23:
              return _context5.abrupt("return", new _Promise(function (resolve) {
                gt.onSuccess(function () {
                  var validate = gt.getValidate();

                  if (!validate) {
                    resolve({
                      success: false,
                      message: '验证码验证失败'
                    });
                  } else {
                    var _context2, _context3;

                    var geetest_challenge = validate.geetest_challenge,
                        geetest_validate = validate.geetest_validate,
                        geetest_seccode = validate.geetest_seccode;
                    resolve({
                      success: true,
                      type: ECaptchaType.Geetest,
                      result: {
                        geetest_challenge: geetest_challenge,
                        geetest_validate: geetest_validate,
                        geetest_seccode: geetest_seccode
                      },
                      captcha_token: _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "geetest|".concat(geetest_challenge, "|")).call(_context3, geetest_validate, "|")).call(_context2, geetest_seccode)
                    });
                  }
                });
                gt.onError( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(err) {
                    var res;
                    return _regeneratorRuntime.wrap(function _callee2$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!(err.msg === 'not proof')) {
                              _context4.next = 8;
                              break;
                            }

                            geetestInstanceRef.current = undefined;
                            captchaRef.current = undefined;
                            _context4.next = 5;
                            return verify();

                          case 5:
                            res = _context4.sent;
                            resolve(res);
                            return _context4.abrupt("return");

                          case 8:
                            resolve({
                              success: false,
                              message: err.msg,
                              cause: err
                            });

                          case 9:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                gt.onClose(function () {
                  resolve({
                    success: false,
                    reason: 'cancelled'
                  });
                });
                gt.onReady(function () {
                  gt.verify();
                });
              }));

            case 24:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee3);
    }));

    return function verify() {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    verify: verify
  };
};

export { useGeetest };
